import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi, { IUpdateCurrentApplicationRequest } from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createUpdateCurrentApplicationThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.UpdateCurrentApplication, 
    async (dto: IUpdateCurrentApplicationRequest) => {
      const response = await api.updateCurrentApplication(dto);
      return response;
  },
);
